import { Parcel } from "../../../../front-office/model/parcel";

export class ParcelAnnounceTrackerCommand {
    private readonly _parcel: Parcel;
    private readonly _carrier: string;
    private readonly _parcelTracker: string;

    constructor(parcel: Parcel, carrier: string, parcelTracker: string) {
        this._parcel = parcel;
        this._carrier = carrier;
        this._parcelTracker = parcelTracker;
    }

    get parcel() {
        return this._parcel;
    }

    get carrier() {
        return this._carrier;
    }

    get parcelTracker() {
        return this._parcelTracker;
    }
}
